import React from "react";
import { Link } from "react-router-dom";

export default class NewPostLink extends React.Component {
  render() {
    return (
      <Link
        to="/create"
        className="btn-floating btn-large halfway-fab waves-effect waves-light teal right"
      >
        <i className="material-icons">+</i>
      </Link>
      // <Link to='/create' className='fixed bg-white top-0 right-0 pa4 ttu dim black no-underline'>
      //   + New Post
      // </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/templates/create-post/NewPostLink.js